const benefits = [
  'Розбір воронки найму',
  'Карту втрат кандидатів',
  'Оцінку часу на ручні процеси',
  'Сценарій інтеграції з ERP',
  'План поступового впровадження',
  'Персональну демонстрацію',
];

export default function CTAFormSection() {
  return (
    <section id="cta" className="py-24 lg:py-32 relative overflow-hidden" style={{ backgroundColor: '#0c1527' }}>
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse 60% 50% at 50% 30%, rgba(249,107,37,0.05) 0%, transparent 70%)',
        }}
      />

      <div className="relative z-10 max-w-[1100px] mx-auto px-6 lg:px-10">

        <div className="text-center mb-14 lg:mb-20 max-w-[700px] mx-auto">
          <h2 className="font-heading font-bold text-white leading-[1.08] tracking-tight mb-5" style={{ fontSize: 'clamp(2rem, 4.5vw, 3.5rem)' }}>
            Отримайте розрахунок<br />
            <span style={{ color: '#F96B25' }}>втрат часу та демо</span>
          </h2>
          <p className="text-white/40 text-lg lg:text-xl leading-relaxed max-w-[480px] mx-auto">
            Покажемо, як наймати до 3 разів швидше, зменшити ручну роботу та інтегрувати HR-процеси з ERP.
          </p>
        </div>

        <div className="max-w-[700px] mx-auto text-center">

          {/* Benefits */}
          <div className="inline-flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mb-10">
            {benefits.map((b) => (
              <div key={b} className="flex items-center gap-2">
                <div
                  className="w-4 h-4 rounded-full flex items-center justify-center flex-shrink-0 border"
                  style={{ backgroundColor: 'rgba(249,107,37,0.12)', borderColor: 'rgba(249,107,37,0.25)' }}
                >
                  <i className="ri-check-line text-[8px]" style={{ color: '#F96B25' }}></i>
                </div>
                <span className="text-white/45 text-base">{b}</span>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <button
            onClick={() => { window.location.href = "https://hurma.work/request-2/?utm_source=industry"; }}
            className="inline-flex items-center justify-center gap-3 bg-[#F96B25] hover:bg-[#e05a14] text-white font-semibold text-lg px-10 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Отримати демо
            <i className="ri-arrow-right-line text-base"></i>
          </button>

          <p className="mt-6 text-white/25 text-sm">
            Безкоштовно. Покажемо сценарій автоматизації саме для вашої структури найму.
          </p>

        </div>

      </div>
    </section>
  );
}